export default __webpack_public_path__ + "static/media/footer.e35d3af1.png";